module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/spaces/HOME_03slide-atnoon.png";